import { Box, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import EditIcon from "@mui/icons-material/Edit";
import ViewImageDialog from "./ViewImageDialog";

const actionIonStyle = {
  fontSize: "1.125rem",
  cursor: "pointer",
};

const AddImages = ({ allImages, setAllImages }) => {
  const imgRef = useRef(null);
  const openViewImageDialog = useRef(null);
  const [editIndex, setEditIndex] = useState(null);

  const handleChangeImages = (event) => {
    const files = event.target.files;

    if (files.length === 0) return;

    const newImages = Array.from(files).map((file) => ({
      image: URL.createObjectURL(file),
      file: file,
    }));

    imgRef.current.value = null;

    if (editIndex !== null) {
      setAllImages((prevImages) => {
        const updatedImages = [...prevImages];
        updatedImages[editIndex] = newImages[0];
        return updatedImages;
      });
      setEditIndex(null);
    } else {
      // Add new images
      setAllImages((prevImages) => [...prevImages, ...newImages]);
    }
  };

  const renderAddImageButton = () => {
    return (
      <>
        <Box
          borderRadius={1.5}
          border={"1px solid #bfbaba"}
          height={100}
          width={100}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          onClick={() => imgRef.current.click()}
          sx={{
            cursor: "pointer",
          }}
        >
          <AddIcon />
        </Box>
        <input
          ref={imgRef}
          type={"file"}
          accept="image/*,video/*"
          style={{ display: "none" }}
          onChange={handleChangeImages}
        />
      </>
    );
  };

  const handleDeleteImage = (index) => {
    let tempArray = [...allImages];
    tempArray.splice(index, 1);
    setAllImages(tempArray);
  };

  const handleEditImage = (index) => {
    setEditIndex(index);
    imgRef.current.click();
  };

  const handleOpenViewImageDialog = (val) => {
    openViewImageDialog.current.openDialog({ data: val });
  };

  return (
    <Box my={2}>
      <Typography variant="h1" fontWeight={600} fontSize={"1.125rem"} mb={2}>
        School Images and Videos{" "}
        <span style={{ fontSize: "0.875rem", fontWeight: 400 }}>
          (Image should be 1080*1080)
        </span>
      </Typography>
      <Grid container>
        <Grid item xs={12} md={8}>
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            {allImages?.map((val, index) => {
              return (
                <Box
                  borderRadius={1.5}
                  border={"1px solid #bfbaba"}
                  key={index}
                  overflow={"hidden"}
                >
                  <Stack
                    direction={"row"}
                    justifyContent={"flex-end"}
                    gap={0.5}
                    p={0.5}
                  >
                    <EditIcon
                      htmlColor="#ffc94b"
                      sx={{ ...actionIonStyle }}
                      onClick={() => handleEditImage(index)}
                    />
                    <HighlightOffIcon
                      htmlColor="red"
                      sx={{ ...actionIonStyle }}
                      onClick={() => handleDeleteImage(index)}
                    />
                  </Stack>
                  <Box
                    height={100}
                    width={100}
                    borderTop={"1px solid #bfbaba"}
                    onClick={() => handleOpenViewImageDialog(val)}
                    sx={{ cursor: "pointer" }}
                  >
                    <img
                      src={val.image}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                </Box>
              );
            })}

            {/* Add more image button */}
            {renderAddImageButton()}
          </Stack>
        </Grid>
      </Grid>
      <ViewImageDialog ref={openViewImageDialog} />
    </Box>
  );
};

export default AddImages;
